import React, { ChangeEvent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { generateIntialErrorMsg, ILoginCreds, ILoginErrorsMsg, validateLoginInfo } from '../../utils/loginUtils';
import "./Account.css";
import { useAppDispatch } from '../../hooks';
import ForgetPasswordPopup from './ForgetPasswordPopup';
import { resetCredentialsInfo, setToken } from '../../reducers/UserSplice';
import { resetTabsData, setActiveTab } from '../../reducers/tabSplice';
import Loader from '../Common/FullscreenLoader/FullScreenLoader';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const [isForgetPassword, setForgetPassword] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [loginForm, setLoginForm] = useState<ILoginCreds>({
        username: '',
        password: '',
    });
    const [errorsMsg, setErrorsMsg] = useState<ILoginErrorsMsg>(generateIntialErrorMsg());
    const [error, setError] = useState("");
    const [isButtonEnabled, setIsButtonEnabled] = useState(false);

    const setApiError = (apiError: string) => {
        setErrorsMsg((prevState: any) => ({
            ...prevState,
            apiError,
        }));
    };

    const resetErrorMsg = (fieldName: string) => {
        setErrorsMsg((prevState: any) => ({
            ...prevState,
            [fieldName]: '',
        }));
    };

    const onUsernameChange = (e: ChangeEvent<HTMLInputElement>) => {
        resetErrorMsg('usernameError');
        setError("")
        setLoginForm({ ...loginForm, username: e.target.value });
    };

    useEffect(() => {
        dispatch(resetCredentialsInfo());
        dispatch(resetTabsData())
    }, [])

    useEffect(() => {
        if (loginForm.username && loginForm.password) {
            setIsButtonEnabled(true);
        } else {
            setIsButtonEnabled(false);
        }
    }, [loginForm])


    const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
        resetErrorMsg('passwordError');
        setError("")
        setLoginForm({ ...loginForm, password: e.target.value });
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            // Simulate a click on the login button
            handleSubmit();
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };


    const handleSubmit = async () => {
        setLoading(true)
        try {
            const validatedInfo = await validateLoginInfo(loginForm);
            if (!validatedInfo.usernameError && !validatedInfo.passwordError) {
                if (validatedInfo.apiResponse) {
                    const { status, data } = validatedInfo.apiResponse;
                    if (status === 200) {
                        dispatch(setActiveTab("dashboard"));
                        dispatch(setToken({
                            access_token: data.data.accessToken,
                            refresh_token: data.data.refreshToken
                        }))
                        // setTimeout(() => {
                            navigate('/dashboard')

                        // }, 1500)
                    }
                    else {
                        setError(validatedInfo.apiResponse.message);
                    }
                }

            }
        } catch (err) {
            setApiError("Login failed! Please try again");
        } finally {
            setLoading(false)
        }
    };

    return (
        <>
            <div className={isForgetPassword ? 'popupOpen' : ''}>
                <div className='login d-flex'>
                    <div className="imgContent">
                        <div className="imgBox mx-auto">
                            <img src={`./assets/images/YGB.png`} alt="logo" />
                        </div>
                        <div className="txt">YOUNG, GIFTED & BEAUTIFUL</div>
                        <div className='loginForm'>
                            <div className="formRow">
                                <input className='formControl' type='text' placeholder='User name' name='username' onChange={onUsernameChange} autoComplete="off" />
                            </div>
                            <div className="formRow">
                                <div className="radioOverlay">
                                    <input className='formControl' type={showPassword ? 'text' : 'password'} placeholder='Password' name="password" onChange={handlePasswordChange} onKeyDown={handleKeyPress} autoComplete="off" />
                                    <label className="customRadio">
                                        <span onClick={togglePasswordVisibility}>
                                            {showPassword ? <img className='checkmark' src='.\assets\images\login\eye-off.svg' alt='eye off' /> : <img className='checkmark' src='.\assets\images\login\eye-on.svg' alt='eye on' />}
                                        </span>
                                    </label>
                                </div>

                            </div>
                            <div className="text-right">
                                <button className="forgetPass btnNoStyle" onClick={() => setForgetPassword(true)}>Forgot my password</button>
                            </div>
                        </div>
                    </div>
                    <p className='error errorText'>{error}</p>
                    <div className='bottomBlock d-flex justify-content-center'>
                        <button className='blueBtn' type="submit" onClick={handleSubmit} disabled={!isButtonEnabled}>
                            Access granted
                        </button>
                    </div>

                </div>
                {isForgetPassword &&
                    <ForgetPasswordPopup
                        onclick={() => setForgetPassword(false)}
                        handleClick={() => navigate("/verify-email")}
                        heading='Forgot your password?'
                        text='Don’t worry we are here to help'
                        buttonTxt1='Reset Password'
                        buttonTxt2='Cancel'
                    />
                }
            </div>
            {loading &&
                <Loader message="Loading, please wait..." />
            }
        </>

    );
};

export default Login;
